// extracted by mini-css-extract-plugin
export var root = "BlogPreview-module--root--5wIz7";
export var blogPreviewImage = "BlogPreview-module--blogPreviewImage--PdURJ";
export var category = "BlogPreview-module--category--rZUTQ";
export var link = "BlogPreview-module--link--fvO9E";
export var title = "BlogPreview-module--title--Z1IiF";
export var excerpt = "BlogPreview-module--excerpt--vjxRD";
export var hideReadMoreOnWeb = "BlogPreview-module--hideReadMoreOnWeb--Fr28s";